import { render, staticRenderFns } from "./team-members-list-footer.vue?vue&type=template&id=6c743ec7&scoped=true&"
import script from "./team-members-list-footer.vue?vue&type=script&lang=ts&"
export * from "./team-members-list-footer.vue?vue&type=script&lang=ts&"
import style0 from "./team-members-list-footer.vue?vue&type=style&index=0&id=6c743ec7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c743ec7",
  null
  
)

export default component.exports